import GalleryService from '@/services/gallery.service';

/**
 * Handles the editing of an artwork.
 * @param {object} formState - The current state of the form.
 * @param {function} setFormError - Function to set form error state.
 * @param {function} navigate - Function from react-router-dom to handle navigation.
 * @param {function} cacheHandler - Custom cache handling utility.
 * @param {function} goBackHandler - Custom cache handling utility.
 * @param {function} onArtworkEdited - handler to do after the edition
 * @returns {Promise<boolean>} - Resolves true if successful, false otherwise.
 */

export async function editArtwork({ 
  formState, 
  setFormError, 
  navigate, 
  cacheHandler, 
  goBackHandler,
  onArtworkEdited = null,
}) {
  const { response, data } = await GalleryService.editArtwork(formState);
  
  if (response.ok) {
    if (data.is_critical) {
      navigate('/inventory/pending', { replace: true });
    } else {
      cacheHandler.storeInCache(
        `artwork_${data.artwork.slug}`, 
        { totalDocs: 1, data: [data.artwork] }, 
        { invalidateWhen: ["EDIT_ARTWORK", "DELETE_ARTWORK", "BUY_ARTWORK"] }
      );
      if(onArtworkEdited) {
        onArtworkEdited();
      }

      goBackHandler();
    }
  } else if (response.status === 400) {
    setFormError([{ element: data.error_data.element, error_code: data.error_type }]);
    return false;
  }
  setFormError([{ element: 'general', error_code: 'SERVER_ERROR' }]);
  return false;
  
}
